/* Wo die Anmeldung liegt: „30 Tage angemeldet bleiben“ (Ansicht 15).
   Gemerkt: localStorage, mit Ablaufdatum nach 30 Tagen. Nicht gemerkt: sessionStorage, endet mit dem Tab. */

export const MERKEN_TAGE = 30;
const SCHLUESSEL_MERKEN = "obsn.merken";
const SCHLUESSEL_BIS = "obsn.angemeldet_bis";

/** Bis wann eine gemerkte Anmeldung gilt. */
export function anmeldungBis(jetzt: Date, tage = MERKEN_TAGE): Date {
  return new Date(jetzt.getTime() + tage * 24 * 60 * 60 * 1000);
}

/** Ist eine gemerkte Anmeldung abgelaufen? Ohne Datum: nein (nicht gemerkt, endet mit dem Tab). */
export function abgelaufen(bisIso: string | null, jetzt: Date): boolean {
  if (!bisIso) return false;
  const bis = new Date(bisIso);
  return Number.isNaN(bis.getTime()) || bis.getTime() <= jetzt.getTime();
}

function lokal(): Storage | null {
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}
function sitzung(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function merkenGewaehlt(): boolean {
  return lokal()?.getItem(SCHLUESSEL_MERKEN) !== "0";
}

/** Vor dem Anmelden aufrufen: Wahl merken und Ablauf setzen. */
export function merkenSetzen(merken: boolean, jetzt = new Date()): void {
  const l = lokal();
  if (!l) return;
  l.setItem(SCHLUESSEL_MERKEN, merken ? "1" : "0");
  if (merken) l.setItem(SCHLUESSEL_BIS, anmeldungBis(jetzt).toISOString());
  else l.removeItem(SCHLUESSEL_BIS);
}

export function angemeldetBis(): string | null {
  return lokal()?.getItem(SCHLUESSEL_BIS) ?? null;
}

export function merkenVergessen(): void {
  lokal()?.removeItem(SCHLUESSEL_BIS);
}

/** Speicher für supabase-js: schreibt je nach Wahl in localStorage oder sessionStorage. */
export const sitzungsSpeicher = {
  getItem(k: string): string | null {
    return lokal()?.getItem(k) ?? sitzung()?.getItem(k) ?? null;
  },
  setItem(k: string, v: string): void {
    if (merkenGewaehlt()) {
      lokal()?.setItem(k, v);
      sitzung()?.removeItem(k);
    } else {
      sitzung()?.setItem(k, v);
      lokal()?.removeItem(k);
    }
  },
  removeItem(k: string): void {
    lokal()?.removeItem(k);
    sitzung()?.removeItem(k);
  },
};

/* Karte „Erste Schritte“ auf Meine Woche (BAUPLAN-PAKETE.md, Abschnitt 4.6): „Ausblenden“ gilt für dieses Gerät und diese Person. */
const SCHLUESSEL_ERSTE_SCHRITTE = "obsn.erste_schritte_aus";

export function ersteSchritteAus(person: string): boolean {
  return lokal()?.getItem(`${SCHLUESSEL_ERSTE_SCHRITTE}.${person}`) === "1";
}

export function ersteSchritteAusblenden(person: string): void {
  lokal()?.setItem(`${SCHLUESSEL_ERSTE_SCHRITTE}.${person}`, "1");
}

/* Wahl je Gerät, zum Beispiel Liste oder Timetable im Line-up (BAUPLAN-TIMETABLE.md, Abschnitt 5.1). Fehlt der Speicher (privates
   Fenster, gesperrt), gilt die Vorgabe. */
const SCHLUESSEL_WAHL = "obsn.wahl";

export function wahlLesen(name: string): string | null {
  try {
    return lokal()?.getItem(`${SCHLUESSEL_WAHL}.${name}`) ?? null;
  } catch {
    return null;
  }
}

export function wahlMerken(name: string, wert: string): void {
  try {
    lokal()?.setItem(`${SCHLUESSEL_WAHL}.${name}`, wert);
  } catch {
    // Ohne Speicher gilt die Wahl nur bis zum Neuladen
  }
}
